module.exports = __webpack_public_path__ + "public/SiteImages/noReviewImage.svg?bf5a3a69";